<script lang="ts">
	import arrowDownLong from "../../../core/assets/icons/arrow-down.svg?raw";
	import Button from "./Button.svelte";
	import { getGlobalSettings } from "../getGlobalSettings";
	import { getContext } from "svelte";
	import { pageSlugContextKey } from "../contexts/pageSlugContextKey";
	import Link from "./Link.svelte";
	import type { GlobalTemplateProps } from "../GlobalTemplateProps.js";
	import { tenants } from "../../../core/config/tenants.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { localeLangMap } from "../../../core/schema/localeLangMap";
	import { getTenant } from "../contexts/tenantContextKey";

	const { WEB_URL } = getGlobalSettings();
	const pageSlug = getContext<GlobalTemplateProps["pageSlug"]>(pageSlugContextKey);
	const { locale } = getTenant();

	let isLanguageListOpen = false;

	function toggleLanguageList(): void {
		isLanguageListOpen = !isLanguageListOpen;
	}
</script>

<div class="group relative">
	<Button
		variant="transparent"
		class="hover:text-primary text-3xs !gap-0.5 font-medium uppercase tracking-[0.125rem] transition-all duration-300 ease-in-out lg:rounded-lg lg:px-4 lg:py-2 group-hover:lg:bg-white"
		iconClass="w-4 group-hover:lg:rotate-180 duration-300 transition-transform ease-in-out"
		icon={arrowDownLong}
		on:click={toggleLanguageList}
	>
		{nbspify(localeLangMap[locale])}
	</Button>
	<div
		class="absolute left-1/2 top-[calc(100%+.25rem)] w-[calc(100%+1rem)] -translate-x-1/2 rounded-lg bg-white shadow-sm transition-opacity duration-300 ease-in-out lg:after:absolute lg:after:-top-1 lg:after:left-0 lg:after:right-0 lg:after:h-1 lg:after:w-full lg:after:content-[''] lg:group-hover:pointer-events-auto lg:group-hover:opacity-100 {isLanguageListOpen
			? 'pointer-events-auto opacity-100 lg:pointer-events-none lg:opacity-0'
			: 'pointer-events-none opacity-0 lg:pointer-events-none lg:opacity-0'}"
	>
		{#each Object.values(tenants) as tenant}
			{#if tenant.locale !== locale}
				<Link
					class="lg:text-3xs hover:text-primary !block w-full rounded-lg p-2 text-center text-xs font-semibold uppercase tracking-[0.125rem] transition-colors duration-300 ease-in-out hover:bg-gray-100 lg:font-normal"
					asButton
					variant="transparent"
					href="{WEB_URL}/{pageSlug[tenant.locale] ?? ''}"
				>
					{nbspify(localeLangMap[tenant.locale])}
				</Link>
			{/if}
		{/each}
	</div>
</div>
